module.exports = __webpack_public_path__ + "static/media/C-check.0b762613.svg";